module.exports = __webpack_public_path__ + "img/img_services_design.7bac6c6c.jpg";